export default "__VITE_ASSET__0v98ezmq__"